import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const UnexpectedErrorScreen = () => (
   <>
      <HelmetProvider>
           <Helmet>
             <title>Unexpected Error</title>
          </Helmet>
      </HelmetProvider>
      <div className="container">
         <h1 className="mt-4">Unexpected Error</h1>
         <p>
            Reload this page and try again later. Contact support if you
            continue to experience this error.
         </p>
      </div>
   </>
);

export { UnexpectedErrorScreen };
